<template>
  <div class="sidebar-pinned">
    <Navbar />

    <main class="admin-main">
      <!--site header begins-->

      <section class="admin-content">
        <div class="container">
          <div class="row">
            <div class="col-12 m-b-20">
              <h5 class="spacer-top">{{ user.full_name }}</h5>
            </div>

            <div class="col-lg-4 col-md-4">
              <div class="card m-b-30">
                <div class="card-body">
                  <div class="pb-2">
                    <router-link :to="{ path: '/view-clients-tpa' }">
                      <div class="avatar avatar-lg">
                        <div
                          class="avatar-title bg-soft-primary rounded-circle"
                        >
                          <i class="fe fe-users"></i>
                        </div>
                      </div>
                    </router-link>
                  </div>
                  <div>
                    <p class="text-muted text-overline m-0">Enrollees</p>
                    <h1 class="fw-400">{{ 1408 | numeral(0, 0) }}</h1>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-4 col-md-4">
              <div class="card m-b-30">
                <div class="card-body">
                  <div class="pb-2">
                    <router-link :to="{ path: '/view-clients-tpa' }">
                      <div class="avatar avatar-lg">
                        <div
                          class="avatar-title bg-soft-primary rounded-circle"
                        >
                          <i class="fe fe-users"></i>
                        </div>
                      </div>
                    </router-link>
                  </div>
                  <div>
                    <p class="text-muted text-overline m-0">Principals</p>
                    <h1 class="fw-400">{{ clients.total }}</h1>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-4 col-md-4">
              <div class="card m-b-30">
                <div class="card-body">
                  <div class="pb-2">
                    <router-link :to="{ path: '/view-clients-tpa' }">
                      <div class="avatar avatar-lg">
                        <div
                          class="avatar-title bg-soft-primary rounded-circle"
                        >
                          <i class="fe fe-users"></i>
                        </div>
                      </div>
                    </router-link>
                  </div>
                  <div>
                    <p class="text-muted text-overline m-0">Dependents</p>
                    <h1 class="fw-400">{{ 1095 | numeral }}</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-10 m-b-30">
              <h5 class="h5"><i class="fe fe-users"></i>Enrollees</h5>
              <div class="table-responsive">
                <table class="table align-td-middle table-card">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Phone Number</th>
                      <th>Sector</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="client in clients.data" v-bind:key="client.id">
                      <td>
                        {{ client.full_name }}
                      </td>
                      <td>{{ client.phone_number }}</td>
                      <td>{{ client.sector }}</td>
                      <td>
                        <router-link :to="{ path: '/client/' + client.id }">
                          <button
                            type="button"
                            name="button"
                            class="btn btn-info"
                          >
                            <i class="fe fe-eye"></i>
                          </button>
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </section>
    </main>
  </div>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
import Footer from "@/views/Footer.vue";
let agency = JSON.parse(localStorage.getItem("agency"));

export default {
  components: {
    Navbar,
    Footer,
  },

  data() {
    return {
      agency: agency,
      auth_user: "",
      OfficerDetails: "",
      clients: "",
      appointments: "",
      providers: "",
      user: null,
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.axios
      .get(`/api/v1/auth/OfficerDetails/${this.user.id}`)
      .then((response) => {
        this.OfficerDetails = response.data.data;
        this.clients = response.data.enrollees;
        // let officer = response.data
        console.log(response);
      })
      .catch((error) => {
        console.error(error);
      });
  },
  methods: {
    //
  },
  created() {},
};
</script>
<style lang="css" scoped>
.spacer-top {
  margin-top: 10px;
}
</style>
